module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Laporan")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Laporan")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  }, [_vm._v("Tambah Data")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('tree-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "border": ""
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33980780!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/LaporanTree.vue
// module id = 1368
// module chunks = 2